import { render } from "./SidebarLogo.vue?vue&type=template&id=5f13e0aa&scoped=true"
import script from "./SidebarLogo.vue?vue&type=script&lang=ts"
export * from "./SidebarLogo.vue?vue&type=script&lang=ts"

import "./SidebarLogo.vue?vue&type=style&index=0&id=5f13e0aa&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5f13e0aa"

export default script